module.exports = __webpack_public_path__ + "images/closed-board-screen/admin-upsell.2ab7538094ebf5594cc5.png";